<template>
    <q-card class="full-height bg-white">
        <q-card-title class="text-center bg-primary text-white">
            {{ $t('ranking') }}
        </q-card-title>

        <q-card-separator />

        <q-card-main class="relative-position">
            <q-list no-border separator striped>
                <q-item v-for="(ranking, index) in filteredRanking" :key="index" v-if="filteredRanking.length > 0">
                    <q-item-side>
                        # {{ index + 1 }}
                    </q-item-side>

                    <q-item-side>
                        <img :src="getImage(ranking)" class="round-avatar" @error="imageUrlAlt" />
                    </q-item-side>

                    <q-item-main>
                        <span class="name">{{ ranking.n }}</span>
                    </q-item-main>

                    <q-item-side class="text-right" v-if="ranking.s">
                        <q-item-tile>{{ getScore(ranking.s) }}</q-item-tile>
                    </q-item-side>

                    <q-item-side class="text-right" v-else>
                        <q-item-tile>{{ getScore(0) }}</q-item-tile>
                    </q-item-side>
                </q-item>

                <q-item v-if="user_position">
                    <q-item-side>
                        # {{ user_position.pos + 1 }}
                    </q-item-side>

                    <q-item-side>
                        <img :src="getImage(user_position)" class="round-avatar" @error="imageUrlAlt" />
                    </q-item-side>

                    <q-item-main>
                        <span class="name">{{ user_position.n }}</span>
                    </q-item-main>

                    <q-item-side class="text-right" v-if="user_position.s">
                        <q-item-tile>{{ getScore(user_position.s) }}</q-item-tile>
                    </q-item-side>

                    <q-item-side class="text-right" v-else>
                        <q-item-tile>{{ getScore(0) }}</q-item-tile>
                    </q-item-side>
                </q-item>
            </q-list>

            <q-list no-border separator dense v-if="filteredRanking.length > 0">
                <q-item>
                    <q-item-main class="text-center">
                        <span class="cursor-pointer text-faded" @click="seeAll()">{{ $t('see_all') }}</span>
                    </q-item-main>
                </q-item>
            </q-list>

            <q-list no-border separator dense v-if="loaded && filteredRanking.length === 0">
                <q-item>
                    <q-item-main class="text-center">
                        {{ $t('no_ranking_found') }}
                    </q-item-main>
                </q-item>
            </q-list>

            <q-inner-loading :visible="filteredRanking.length == 0 && !loaded">
                <q-spinner-dots :size="60" color="secondary"></q-spinner-dots>
            </q-inner-loading>
        </q-card-main>
    </q-card>
</template>

<script>
import { db } from 'plugins/vuefire'
import { mapGetters } from 'vuex'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "feed"] },

    props: ['ranking_code'],

    data() {
        return {
            rankings: [],
            ordered_ranking: [],
            user_position: null,
            loaded: false
        }
    },

    computed: {
        ...mapGetters({
            id: 'common/id',
            user_firebase_document: 'common/user_firebase_document',
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected'
        }),

        filteredRanking() {
            if (this.rankings && this.rankings.users) {
                this.ordered_ranking = this.rankings.users.sort((a,b) => (parseFloat(a.s) < parseFloat(b.s)) ? 1 : ((parseFloat(b.s) < parseFloat(a.s)) ? -1 : 0))

                let obj = this.ordered_ranking.find((obj) => { return obj.i === this.id })
                if (obj) {
                    this.user_position = obj
                    let pos = this.rankings.users.map((e) => { return e.i }).indexOf(this.user_position.i)
                    if (pos > 4) {
                        this.user_position.pos = pos
                    }
                    else {
                        this.user_position = null
                    }
                }
                else {
                    this.user_position = null
                }

                return this.ordered_ranking.slice(0, 5)
            }
            else return []
        }
    },

    methods: {
        getImage(ranking) {
            return `${process.env.BUCKET_URL}media/users/${ranking.i}/images/50x50.jpg`
        },

        imageUrlAlt(event) {
            let alt = 'statics/user-alt.svg'
            event.target.src = alt
            event.target.classList = 'round-avatar outline-avatar'
        },

        seeAll() {
            this.$emit('seeAll')
        },

        getScore(score) {
            let client = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })

            if (client && client.ranking_use_decimal) return score.toFixed(2)
            else return score.toFixed(0)
        }
    },

    watch: {
        user_firebase_document: {
            handler: function(newValue) {
                this.$unbind('rankings')
                this.user_position = null
                this.rankings = []
                this.loaded = false

                this.$bind('rankings', db.collection('ranking').doc(`${this.ranking_code ? this.ranking_code : this.user_firebase_document}`)).then(rankings => {
                    this.rankings === rankings
                })
                .then(()=> {
                    this.loaded = true
                })
            },
            deep: true
        },

        ranking_code: {
            handler: function(newValue) {
                this.$unbind('rankings')
                this.user_position = null
                this.rankings = []
                this.loaded = false

                this.$bind('rankings', db.collection('ranking').doc(`${this.ranking_code ? this.ranking_code : this.user_firebase_document}`)).then(rankings => {
                    this.rankings === rankings
                })
                .then(()=> {
                    this.loaded = true
                })
            },
            deep: true
        }
    },

    created() {
        this.$bind('rankings', db.collection('ranking').doc(`${this.ranking_code ? this.ranking_code : this.user_firebase_document}`)).then(rankings => {
            this.rankings === rankings
        })
        .then(()=> {
            this.loaded = true
        })
    }
}
</script>

<style lang="stylus" scoped>
.round-avatar
    width 2.5rem
    height 2.5rem
    border-radius 50%

.outline-avatar
    border 2px solid black

.name
    line-height 1.5rem
    display -webkit-box
    -webkit-line-clamp 1
    -webkit-box-orient vertical
    overflow hidden
</style>
